import { DocumentSource } from '@types'

import { initDropboxPicker, useGooglePicker, initOneDrivePicker } from './utils'

export const useDocumentService = (
  callback: (name: string, path: string, source: DocumentSource) => void,
) => {
  const googlePicker = useGooglePicker()

  const onSelectService = (value: DocumentSource) => {
    switch (value) {
      case DocumentSource.GOOGLE_DRIVE:
        googlePicker.open(result => {
          callback(result.name, result.url, value)
        })
        break
      case DocumentSource.DROPBOX:
        initDropboxPicker(result => {
          callback(result.name, result.link, value)
        })
        break
      case DocumentSource.ONE_DRIVE:
        initOneDrivePicker(result => {
          callback(result.name, result.webUrl, value)
        })
        break
      default:
        callback('', '', value)
        break
    }
  }

  return {
    onSelectService,
  }
}
